/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import { RingLoader, BeatLoader } from 'react-spinners';

import { COLORS } from '../../assets/constants/strings';

const Loader = ({ text, subText, card }) => {
  return card ? (
    <div className='w-100 d-flex flex-column justify-content-center align-items-center my-2'>
      <BeatLoader color={COLORS.DEFAULT} size='1em' />
      <b style={{ color: COLORS.DEFAULT, fontSize: '1.15em' }}>Loading...</b>
    </div>
  ) : (
    <div className='mt-5 w-100 d-flex justify-content-center align-items-center flex-column text-center'>
      <RingLoader color={COLORS.DEFAULT} size={120} />
      <h2 style={{ color: COLORS.DEFAULT }}>{text ? text : 'Loading...'}</h2>
      {!text && !subText && (
        <h4
          id='extra-load-text'
          style={{ color: COLORS.DEFAULT_SECONDARY }}
        ></h4>
      )}
      {subText && (
        <h4 id='extra-load-text' style={{ color: COLORS.DEFAULT_SECONDARY }}>
          {subText}
        </h4>
      )}
    </div>
  );
};

export default Loader;
